var home = {
	init: function(){
		var kvTimer;
		var isVisible;
		let isVisited = Cookies.get("jins1day_visited");
		let $videoMain = "";
		if(isSmallScreen){
			$videoMain = $("#main_movie_sp");
		}else{
			$videoMain = $("#main_movie_pc");
		}
		
		if(isVisited != 1){
			Cookies.set('jins1day_visited', 1, {
				//secure: true,
				expires: 1,
				domain: location.domainname
			});
			$videoMain[0].play();
		}else{
			//訪問済み
			//映像ではなく、決めの画像にする
			$("#main").addClass("movie_end");
			$("#main").addClass("active");
			$("#main").addClass("show_logo");
			$html.classList.add("show_header");
		}
		

		common.resize();
		home.resize();
		if(!isSmallScreen){
			setTimeout(function(){
				let time = $("#main_movie_sp")[0].currentTime;
				let videoEnd = $("#main_movie_sp")[0].duration;
				$("#main_movie_sp")[0].currentTime = videoEnd;
				$("#main_movie_sp")[0].pause();
			}, 1000);
		}
		kvTimer = setInterval(function(){
			let time = $videoMain[0].currentTime;
			let videoEnd = $videoMain[0].duration;
			if(time >= videoEnd -1){
				$("#main").addClass("active");
				if(time > videoEnd - .2){
					clearInterval(kvTimer);
					$videoMain[0].pause();
					clearInterval(kvTimer);
					setTimeout(function(){
						$("#main").addClass("show_logo");
						$html.classList.add("show_header");
					}, 50);
				}
			}
		}, 33);
	},
	resize: function(){
		let winW = $(window).width(),
			winH = $(window).height();

		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		
		if(!isSmallScreen){
			let sizes = fs(1920,1080,864,486,winW,winH);
			$("#movie_main video#main_movie_pc").css({
				"width": "",
				"height": "",
				"top": "",
				"left": ""
			});
			$("#main").css({
				"width": "",
				"height": winH + "px"
			});
			$("#movie_main").css({
				"width": "",
				"height": ""
			});
		}else{
			$("#movie_main").css({
				"width": winW + "px",
				"height": winH + "px"
			});
			$("#main").css({
				"height": ""
			});
			let sizes = fs(1080,1920,320,569,winW,winH);
			$("#movie_main video#main_movie_sp").css({
				"width": sizes[0] + "px",
				"height": sizes[1] + "px",
				"top": sizes[3] + "px",
				"left": sizes[2] + "px"
			});
		}
	}
}